import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/services';
import { Subscription } from 'rxjs';
import { QuickstartHomeMenuService } from '../../services/quickstart-home-menu.service';

@Component({
    templateUrl: './home.template.html',
    styleUrls: ['./home.style.scss'],
})
export class HomeView implements OnInit {
    firstName = '';
    selected: 'quickstart' | 'inbox' | null = null;

    private subscription: Subscription | null = null;
    constructor(
        public menuService: QuickstartHomeMenuService,
        private authService: AuthService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.firstName = this.authService.employee.firstName ?? '';
        this.subscription = this.route.queryParams.subscribe((p) => {
            if (p.view === 'inbox') {
                this.selected = 'inbox';
                return;
            }

            this.selected = 'quickstart';
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
